import { render } from "./WaitingRoomScreen.vue?vue&type=template&id=885fec38"
import script from "./WaitingRoomScreen.vue?vue&type=script&lang=js"
export * from "./WaitingRoomScreen.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__